import * as React from 'react'
import { Block, Division } from '$views/components'
import { Checkbox } from '$views/components/Checkbox'
import { FieldProps } from 'formik'

interface Props {
  label: string
  options: { key: string; value: string; icon: string }[]
  draftName: string
  onBlur: (event: any) => void
}

export const CaresField: React.FC<Props & FieldProps<any>> = ({ form, options, onBlur }) => {
  const isChecked = (fieldName: string) => {
    return Boolean(form.values[fieldName])
  }

  const onChangeValues = event => {
    const updatedFormValues = { ...form.values, [event.target.name]: event.target.checked }
    form.setValues(updatedFormValues)
  }

  return (
    <Block>
      {options.map(option => (
        <Checkbox
          key={option.key}
          name={option.key}
          onChange={onChangeValues}
          onBlur={onBlur}
          label={option.value}
          icon={option.icon}
          isChecked={isChecked}
        />
      ))}
      <Division color="lightGrey" />
    </Block>
  )
}



// WEBPACK FOOTER //
// ./src/views/RecommendationsForms/ResidenceForm/CareStep/components/CaresField.tsx